import StarRating from "./StarRating";
export { default as StarRatingDisplay } from "./StarRatingDisplay";

export default StarRating;
